import { ShieldCheck, FileCheck2, MapPin, AlertTriangle, TrendingUp } from "lucide-react";

export const LicaraMock = ({ className = "" }) => {
  return (
    <div
      className={`noise-overlay relative overflow-hidden rounded-2xl border border-border bg-[hsl(220_30%_8%)] shadow-[var(--shadow-card)] ${className}`}
      data-testid="licara-product-mock"
    >
      {/* Window bar */}
      <div className="flex items-center gap-2 border-b border-border bg-[hsl(220_28%_10%)] px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-[#FF5A5F]/70" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#FFB020]/70" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#2FE39B]/70" />
        <span className="ml-3 font-mono text-xs text-muted-foreground">
          licara.sentira.io/dashboard
        </span>
      </div>

      <div className="p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-widest text-primary">
              Enforcement Hub
            </p>
            <h3 className="mt-1 text-lg font-semibold">Operations Overview</h3>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-secondary px-3 py-1 text-xs text-muted-foreground">
            <ShieldCheck className="h-3.5 w-3.5 text-primary" /> Secure
          </span>
        </div>

        {/* Stat tiles */}
        <div className="mt-5 grid grid-cols-3 gap-3">
          {[
            { label: "Active Permits", value: "1,284", icon: FileCheck2 },
            { label: "Open Cases", value: "312", icon: AlertTriangle },
            { label: "Field Officers", value: "48", icon: MapPin },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-border bg-[hsl(220_28%_10%)] p-3"
            >
              <s.icon className="h-4 w-4 text-primary" />
              <p className="mt-2 text-xl font-semibold">{s.value}</p>
              <p className="text-[11px] text-muted-foreground">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Chart mock */}
        <div className="mt-4 rounded-xl border border-border bg-[hsl(220_28%_10%)] p-4">
          <div className="flex items-center justify-between">
            <p className="text-xs text-muted-foreground">Resolutions this quarter</p>
            <span className="inline-flex items-center gap-1 text-xs text-[#2FE39B]">
              <TrendingUp className="h-3.5 w-3.5" /> +18%
            </span>
          </div>
          <div className="mt-4 flex h-24 items-end gap-2">
            {[38, 52, 44, 66, 58, 74, 62, 88, 80, 96].map((h, i) => (
              <div
                key={i}
                className="flex-1 rounded-t-sm bg-primary/70"
                style={{ height: `${h}%`, opacity: 0.35 + (i / 20) }}
              />
            ))}
          </div>
        </div>

        {/* Row list */}
        <div className="mt-4 space-y-2">
          {[
            { id: "CASE-4821", label: "Zoning violation — 4th St", status: "In Review", tone: "text-[#FFB020]" },
            { id: "PERMIT-9910", label: "Business license renewal", status: "Approved", tone: "text-[#2FE39B]" },
          ].map((row) => (
            <div
              key={row.id}
              className="flex items-center justify-between rounded-lg border border-border bg-[hsl(220_28%_10%)] px-3 py-2.5"
            >
              <div className="flex items-center gap-3">
                <span className="font-mono text-[11px] text-muted-foreground">{row.id}</span>
                <span className="text-xs text-foreground">{row.label}</span>
              </div>
              <span className={`text-[11px] ${row.tone}`}>{row.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LicaraMock;
